module.exports = __webpack_public_path__ + "img/snap_promo.4e154c0e.png";